// frontend/src/components/common/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <div className="footer-content">
                <p className="footer-copyright">
                    © {currentYear} Abhyaas Educational Trust. All rights reserved.
                </p>
                <p className="footer-credit">
                    Crafted by <a href="https://neuralway.ai" target="_blank" rel="noopener noreferrer">neuralway.ai</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;